// Pill / radio options for the Kindergarten Initial Observations form.

export const yearOptions = [
  { value: 'Year 1', label: 'Year 1 (JK)' },
  { value: 'Year 2', label: 'Year 2 (SK)' },
]

export const frenchOptions = [
  { value: '',          label: 'None' },
  { value: 'Immersion', label: 'Immersion' },
  { value: 'Core',      label: 'Core' },
  { value: 'Extended',  label: 'Extended' },
]
